export const Nav = () => {
    return (
    <div className="flex flex-col overflow-auto text-gray-700 bg-gradient-to-tr from-gray-200 via-indigo-200 to-pink-200">
        <div className="flex items-center flex-shrink-0 w-full h-16 px-10 bg-white bg-opacity-75">
            <svg className="w-8 h-8 text-indigo-600 stroke-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
            </svg>
            <div className="ml-10">
                <a className="mx-2 text-sm font-semibold text-indigo-700" href="#">Overview</a>
                <a className="mx-2 text-sm font-semibold text-gray-600 hover:text-indigo-700" href="#">Annotators</a>
                <a className="mx-2 text-sm font-semibold text-gray-600 hover:text-indigo-700" href="#">Projects</a>
            </div>
            <button className="flex items-center justify-center w-10 h-10 ml-auto overflow-hidden rounded-full cursor-pointer">
                <img src="https://e7.pngegg.com/pngimages/694/639/png-clipart-computer-icons-user-profile-female-symbol-miscellaneous-purple.png" alt="" />
            </button>
        </div>
    </div>
  )
} 
